import { useCallback } from 'react';
import { useRecoilState } from 'recoil';

import Chatbot from '../../components/chatbot/Chatbot';
import { chatbotSessionState } from '../../models/chatbot/recoil-state';
import { useSuggestionsQuery } from '../../common/queries/use-chatbot-query';
import { usePatronSelector } from '../../common/use-patron-selector';
import programSelectors from '../../models/program/selectors';
import styles from './assistant-side-panel.module.scss';

export function ChatbotHome() {
  const [chatbotSession, setChatbotSession] =
    useRecoilState(chatbotSessionState);
  const { threadId, isThreadPersisted, shouldFocusInput } = chatbotSession;

  const programId = usePatronSelector(programSelectors.getProgramId);

  // Fetch suggestions - always available for fresh conversations
  const { data: suggestionsData } = useSuggestionsQuery(programId, {
    enabled: !!programId,
  });

  const handleThreadChange = useCallback(
    (newThreadId: string, persisted = false) => {
      setChatbotSession((prev) => ({
        ...prev,
        threadId: newThreadId,
        isThreadPersisted: persisted,
      }));
    },
    [setChatbotSession]
  );

  const handleFocusHandled = useCallback(() => {
    setChatbotSession((prev) => ({
      ...prev,
      shouldFocusInput: false,
    }));
  }, [setChatbotSession]);

  return (
    <section className={styles.assistantLanding} aria-label="Chatbot Assistant">
      <Chatbot
        threadId={threadId}
        isThreadPersisted={isThreadPersisted}
        onThreadChange={handleThreadChange}
        suggestions={suggestionsData?.suggestions}
        shouldFocusInput={shouldFocusInput}
        onFocusHandled={handleFocusHandled}
      />
    </section>
  );
}

export default ChatbotHome;
